export const PROJECTS = [
    {
      title: "Husqr",
      description: "Social media application utilizing a Firebase backend and an Angular front-end.",
      url: "https://husqr-1074b.web.app",
      repo: "https://github.com/calejc/husqr",
      stack: ["Angular", "Firebase", "Google Cloud", "Bootstrap", "Angular-Material"]
    },
    {
      title: "Movie Database",
      description: "Java Spring Boot application to browse movies and their cast, actors and their credits, and more.",
      url: "https://mcc-movies.herokuapp.com/about",
      repo: "https://github.com/calejc/movies-project",
      stack: ["Java", "Spring Boot", "Bootstrap"]
    },
    {
      title: "Twitter Thread Unroller",
      description: "Unrolls a twitter thread, producing a text file available for download.",
      url: "https://unthreader-i2idck4nea-uc.a.run.app",
      repo: "https://github.com/calejc/bushleaguesports",
      stack: ["Python", "Flask", "Google Cloud", "Bootstrap"]
    },
    {
      title: "Dice Roller",
      description: "Simple dice rolling game in a React single-page application. A basic experiment to see how the useState hook works.",
      url: "https://dice-roller-a091a.firebaseapp.com/",
      repo: "https://github.com/calejc/react-dice-roller",
      stack: ["React", "Firebase", "Google Cloud"]
    },
    {
      title: "Bush League Sports",
      description: "Various sports data, daily fantasy sports information, and betting odds using python Pandas and Flask.",
      url: "https://bush-league-sports.herokuapp.com",
      repo: "https://github.com/calejc/bushleaguesports",
      stack: ["Python", "Flask", "Pandas", "Bootstrap"]
    },
    {
      title: "Rock, Paper, Scissors",
      description: "Static version of the classic game, Rock, Paper, Scissors, using vanilla Javascript.",
      url: "https://calejc-rps.herokuapp.com/",
      repo: "https://github.com/calejc/rps",
      stack: ["HTML", "CSS", "Javascript"]
    },
    {
      title: "Integer Flashcards",
      description: "Practice arithmetic flashcards with two different options for students to choose from. Designed to be embedded into a Google Site, using the Google Apps Script.",
      url: "https://script.google.com/macros/s/AKfycbyyw602VxazPbrCBfjoi6c3jQEYlS3CinEQxuK6HF6bf4IGtbaq/exec",
      repo: "https://github.com/calejc/flashcards",
      stack: ["HTML", "CSS", "Javascript", "Google App Script"]
    },
  ]
  export const TOOLS = [
    {
      name: 'HTML', 
      class: 'html'
    },
    {
      name: "Java", 
      class: "java"
    },
    {
      name: "Javascript", 
      class: "js"
    },
    {
      name: "CSS", 
      class: "css"
    },
    {
      name: "Google App Script", 
      class: "gas"
    },
    {
      name: "Python", 
      class: "python"
    },
    {
      name: "Flask", 
      class: "flask"
    },
    {
      name: "Pandas", 
      class: "pd"
    },
    {
      name: "Bootstrap", 
      class: "bs"
    },
    {
      name: "Spring Boot", 
      class: "spring"
    },
    {
      name: "Thymeleaf", 
      class: "tl"
    },
    {
      name: "Angular", 
      class: "angular"
    },
    {
      name: "Firebase", 
      class: "fb"
    },
    {
      name: "Angular-Material", 
      class: "ang-mat"
    },
    {
      name: "Google Cloud", 
      class: "gcp"
    },
    {
      name: "React",
      class: "react"
    }
  ]